<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdPpHeaderInfoModifyResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      header-btn-edit-disabled
                                      with-custom-row-actions-first-column
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button
                                            v-if="row.status === 1"
                                            type="qualified"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="处理任务"
                                            confirm-text="是否确认开始处理该任务"
                                            :busy="loading"
                                            @click="finishTask(row,'handle')"
                                        ></em-button>
                                        <em-button
                                            v-if="row.status === 1"
                                            type="qualified"
                                            class="btn btn-outline-primary btn-sm"
                                            custom-icon="fa fa-times"
                                            customLabel="拒绝任务"
                                            :busy="loading"
                                            @click="$refs.rejectModal.showModal(row)"
                                        ></em-button>
                                        <em-button
                                            v-if="row.status === 2"
                                            type="save"
                                            custom-icon="fas fa-fw fa-lg fa-circle"
                                            custom-label="完成任务"
                                            class="btn btn-outline-primary btn-sm"
                                            @click="finishTask(row,'finish')"
                                            :busy="loading"
                                            confirm-text="是否确认完成该任务"
                                        ></em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <ReBModal ref="rejectModal" header="拒绝理由"
                  @ok="finishTask(null, 'reject', rejectReason)">
            <DiverseInput :config="inputConfig" :value.sync="rejectReason"></DiverseInput>
        </ReBModal>
    </div>
</template>
<script>
// Author LiangGangQiang
// Date 2021-08-26 16:30:12

import emCommonListMixin from "@/mixin/em/common/list";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";

export default {
    name: "sithMesPrdPpHeaderInfoModifyListView",
    components: {DiverseInput, ReBModal},
    mixins: [emCommonListMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            loading: false,
            rejectReason: null,
            inputConfig: {
                label: '拒绝原因',
                type: 'input'
            }
        }
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('id')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
            this.$refs.emListFilter.doQuery();
        }
    },
    methods: {
        finishTask(row, handle, reason) {
            this.loading = true;

            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpHeaderInfoModify/" + handle + "Task",
                data: {
                    id: row == null ? this.$refs.rejectModal.getTempObject().id : row.id,
                    rejectReason: reason
                }
            }).then(() => {
                this.$message.success("操作成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.loading = false);
        }
    }
};
</script>